export interface MockTerritory {
  firstName: string;
  lastName: string;
  routeNumber: string;
}

export function generateMockTerritories(count = 20): MockTerritory[] {
  let territories: MockTerritory[] = [];
  for (let i = 0; i < count; ++i) {
    territories.push({
      firstName: `firstName`,
      lastName: `lastName`,
      routeNumber: `${i}${i}${i}${i}${i}${i}${i}${i}`,
    });
  }
  return territories;
}
